export const ROUTES = {
  contract: (contractId: string = ':contractId') => `${ROUTES.contracts()}/${contractId}` as const,
  contractNew: () => `${ROUTES.contracts()}/new` as const,
  contracts: () => `${ROUTES.root()}/contracts` as const,
  dashboard: () => `${ROUTES.root()}/dashboard` as const,
  index: () => `${ROUTES.contracts()}` as const,
  root: () => '/contract-management' as const,
};
